import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiCamera}=FiIcons;

function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-white border-t border-slate-100 mt-20">
      <div className="max-w-6xl mx-auto px-4 py-16">
        <div className="flex flex-col items-center text-center space-y-8">
          <div className="flex items-center space-x-3 grayscale opacity-50">
            <SafeIcon icon={FiCamera} className="text-xl" />
            <span className="text-xs font-bold uppercase tracking-[0.4em]">PÓSEFLIO</span>
          </div>
          
          <p className="text-xs text-slate-400 leading-relaxed max-w-md font-light uppercase tracking-widest">
            The definitive resource for professional subject direction and posing excellence.
          </p>
          
          <div className="pt-8 w-full border-t border-slate-50 flex flex-col items-center justify-center">
            <div className="text-slate-400 text-[10px] uppercase tracking-widest font-bold">
              © {currentYear} <a href="https://matchadesign.com" target="_blank" rel="noopener noreferrer" className="text-brand-primary hover:underline">Matcha Design</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;